import { StyleSheet } from 'react-native';
import { THEME_COLORS } from '../../theme/constants/themeColors';
import { COLORS } from '../../config/colors';
import { THEME_STYLES } from '../../theme/constants/themeStyles';

const padding = 16;

export const StyleHelpers = StyleSheet.create({
  safeAreaView: {
    flex: 1,
    backgroundColor: THEME_COLORS.bgColor,
    marginTop: -5
  },
  totalCenter: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  rowStyle: {
    flexDirection: 'row'
  },
  verticalCenter: {
    justifyContent: 'center'
  },
  verticallyCenteredRow: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 0,
    padding: padding,
    backgroundColor: THEME_COLORS.defaultStatusBar,
    ...THEME_STYLES.themeBorder,
    borderRadius: 0,
    borderBottomColor: THEME_COLORS.neutralBorderColor,
    borderWidth: 0,
    borderBottomWidth: 1,
  },
  root: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: THEME_COLORS.bgColor,
    justifyContent: 'space-between'
  },
  actionBar: {
    padding: padding
  },
  horizontallyCenteredRow: {
    flexDirection: 'row',
    justifyContent: 'center'
  },
  pageSpacing: {
    paddingLeft: padding,
    paddingRight: padding
  },
  shadow: {
    // iOS
    shadowColor: COLORS.darkBlack,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.15,
    shadowRadius: 6,
    // android
    elevation: 4,
  },
  themeBorder: {
    borderColor: THEME_COLORS.cardBorderColor,
    borderWidth: 1,
    borderBottomWidth: 1,
    borderRadius: 16,
    ...THEME_STYLES.themeBorder,
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: COLORS.dividerColor
  }
});
